var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertsIconViolet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0012 3C11.0247 3 7.80117 6.22355 7.80117 10.2V19.1761L6.64778 20.2246C5.5059 21.2627 4.93496 21.7817 4.88446 22.2314C4.84069 22.6211 4.99013 23.0076 5.28468 23.2666C5.62451 23.5653 6.39611 23.5653 7.93932 23.5653H11.7816C11.7816 25.3436 13.2232 26.7852 15.0016 26.7852C16.7799 26.7852 18.2215 25.3436 18.2216 23.5653H22.0635C23.6067 23.5653 24.3783 23.5653 24.7181 23.2666C25.0127 23.0076 25.1621 22.6211 25.1184 22.2314C25.0679 21.7817 24.4969 21.2627 23.355 20.2246L22.2012 19.1756V10.2C22.2012 6.22355 18.9776 3 15.0012 3ZM9.44117 19.9016V10.2C9.44117 7.1293 11.9305 4.64 15.0012 4.64C18.0719 4.64 20.5612 7.1293 20.5612 10.2V19.9011L22.2519 21.4381C22.4547 21.6225 22.6307 21.7827 22.7837 21.9237C22.5756 21.9251 22.3377 21.9253 22.0635 21.9253H7.93932C7.66516 21.9253 7.4272 21.9251 7.21917 21.9237C7.37215 21.7827 7.5481 21.6225 7.75096 21.4381L9.44117 19.9016ZM16.5816 23.5653H13.4216C13.4216 24.4379 14.129 25.1452 15.0016 25.1452C15.8741 25.1452 16.5815 24.4379 16.5816 23.5653Z",
    fill: "#9356F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertsIconViolet);
export default __webpack_public_path__ + "static/media/alerts_icon_violet.a6ca8c484a031d032fb39a6baf79c9af.svg";
export { ForwardRef as ReactComponent };